import * as React from "react";
import DocumentTitle from "react-document-title";
import Grid from "@material-ui/core/Grid";
import { observer } from "mobx-react-lite";
import { StudentsProfilesTable } from "../../features/Tables/StudentsProfilesTable/StudentsProfilesTable";
import { StudentsSearch } from "../../features/StudentsSearch/StudentsSearch";
import { useGetUsers } from "../../helpers/hooks/useGetUsers";
import { UserRoleEnum } from "../../static/enums/UserRole";
import { uiStore } from "../../mobx/stores/UiStore/UiStore";

export const StudentsProfilesPage = observer(() => {
  const { loading } = uiStore;
  useGetUsers({ role: UserRoleEnum.student });

  return (
    <DocumentTitle title={"Ученики - Mindset.Digital"}>
      <Grid container spacing={3}>
        <StudentsSearch loading={loading} />
        <StudentsProfilesTable loading={loading} />
      </Grid>
    </DocumentTitle>
  );
});
